export default "__VITE_ASSET__CeEtq4vM__"